import React, { lazy, Suspense, useEffect, useState } from "react";
import { useRoutes, useParams, useLocation, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import DOMLayout from "../components/layout";
import Redirect from "../../components/Redirect";

const IndexRoutes = () => {
    const element = useRoutes([
        {
            element: <LangCom />,
            children: [
                {
                    path:"/",
                    element: LazyLoad("pages/home"),
                },
                {
                    path: "/:lang",
                    children: [
                        {
                            index: true,
                            element: LazyLoad("pages/home"),
                        },
                    ],
                },
            ],
        },
        {
            path: "*",
            element: <Redirect to={"/"} />,
        },
    ]);
    return element;
};

const LazyLoad = (path) => {
    const Comp = lazy(() => import("../" + path));
    return (
        <Suspense fallback={null}>
            <Comp />
        </Suspense>
    );
};

//路由拦截
const AuthCom = ({ children }) => {
    const { lang } = useParams();
    const isLogin = useSelector((i) => i.auth.token);
    return isLogin ? children : <Redirect to={`${lang ? "/" + lang : "/"}`} />;
};

const LangCom = () => {
    let location = useLocation();
    const { lang } = useParams();
    const { i18n } = useTranslation();
    useEffect(() => {
        i18n.changeLanguage(lang ?? "zh");
    }, [location.pathname]);
    return (
        <DOMLayout>
            <Outlet />
        </DOMLayout>
    );
};

export default IndexRoutes;
